export var historyTabs = {
  ACTIVE: "active",
  PAST: "past"
};